import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@omni/components/components/WithdrawalForm/withdrawalForm.container"
    ).then((module) => ({
        default: module.WithdrawalForm
    }))
);
